<section class="content-form">
	<div class="content-form__status-block">
		@switch (item.status) {
			@case ('WAITING') {
				<h3 class="content-form__title">Заявление на&nbsp;подпись</h3>
				<div class="content-form__row">
					<app-checkbox-field
						[customFormControl]="checkboxStatementControl"
					></app-checkbox-field>
				</div>
				<div class="content-form__row content-form__row--button-wrapper">
					<app-action-button-field
						[customFormControl]="submitButtonControl"
					></app-action-button-field>
					<app-tooltip-popup
						[title]="'Отклонить'"
						[buttonType]="'defaultGreen'"
						[position]="'bottom'"
						(openPopup)="onOpenPopup()"
						#tooltip
					>
						<message
							#rejectStatementResult
							[type]="'short'"
						>
							<ng-container mainContent>
								<h3 class="content-form__question-title">
									Вы&nbsp;уверены в&nbsp;отмене заявления?
								</h3>
								<div class="content-form__question-button-wrapper">
									<button
										class="button content-form__question-button content-form__question-button--submit"
										type="button"
										(click)="rejectStatement()"
									>
										Да
									</button>
									<button
										class="button-text content-form__question-button"
										type="button"
										(click)="closePopup()"
									>
										Нет
									</button>
								</div>
							</ng-container>
						</message>
					</app-tooltip-popup>
				</div>
			}
		}
	</div>
</section>
